import {createActionGroup} from '@ngrx/store';
import {QUERY_PARAMS_FEATURE_KEY} from './query-params.types';
import {Params} from '@angular/router';

// For each app to call in an adapter file, using its own RouteName type.
export function createQueryParamsActions<RouteNameType extends string = string>() {
  return createActionGroup({
    source: QUERY_PARAMS_FEATURE_KEY,
    events: {
      'Save': (routeName: RouteNameType, queryParams: Params) => ({routeName, queryParams}),
      'Clear': (routeName: RouteNameType) => ({routeName})
    }
  });
}

// For Aviary use only.
export const QueryParamsActions = createQueryParamsActions<string>();
